export const DAY_PARITIES = ['odd', 'even'] as const
